import { Text } from '@dixa/lib-shared-habla';

export function RoutedThroughClose(): JSX.Element {
  return (
    <Text.Paragraph>Close · Automation closed the conversation</Text.Paragraph>
  );
}
